<script>
  export default {
    props: {
      value: { type: String, default: '' },
      sugestoes: { type: Array, default: () => [] },
      cadastrados: { type: Array, default: () => [] },
      digitados: { type: Array, default: () => [] },
      tituloDigitados: { type: String, default: 'Já digitado' },
      maxlength: { type: Number, default: 300 },
      placeholder: { type: String, default: '' },
      tituloSugestoes: { type: String, default: 'Sugestões do extrato' },
      sugestoesPrimeiro: { type: Boolean, default: false },
    },
    data() {
      return {
        aberto: false,
        timerFechar: null,
        estilo: {},
      }
    },
    computed: {
      opcoesDigitadas() {
        return this.disponiveis(this.digitados, []);
      },
      opcoes() {
        return this.disponiveis(this.sugestoes, this.opcoesDigitadas);
      },
      opcoesCadastradas() {
        return this.disponiveis(this.cadastrados, this.opcoesDigitadas, true);
      },
      temOpcoes() {
        return this.opcoesDigitadas.length > 0 || this.opcoes.length > 0 || this.opcoesCadastradas.length > 0;
      },
    },
    watch: {
      aberto(valor) {
        if (valor) {
          this.posicionar();
          window.addEventListener('scroll', this.posicionar, true);
          window.addEventListener('resize', this.posicionar);
          return;
        }
        window.removeEventListener('scroll', this.posicionar, true);
        window.removeEventListener('resize', this.posicionar);
      },
    },
    beforeDestroy() {
      clearTimeout(this.timerFechar);
      window.removeEventListener('scroll', this.posicionar, true);
      window.removeEventListener('resize', this.posicionar);
    },
    methods: {
      posicionar() {
        const campo = this.$refs.campo;
        if (!campo) return;

        const r = campo.getBoundingClientRect();
        const espacoAbaixo = window.innerHeight - r.bottom;
        const altura = Math.max(140, Math.min(210, espacoAbaixo - 12));
        const paraCima = espacoAbaixo < 160 && r.top > espacoAbaixo;

        this.estilo = paraCima
          ? { left: r.left + 'px', width: r.width + 'px', bottom: (window.innerHeight - r.top + 3) + 'px', maxHeight: Math.min(210, r.top - 12) + 'px' }
          : { left: r.left + 'px', width: r.width + 'px', top: (r.bottom + 3) + 'px', maxHeight: altura + 'px' };
      },
      abrir() {
        clearTimeout(this.timerFechar);
        this.aberto = true;
        this.$nextTick(() => this.posicionar());
      },
      fechar() {
        this.timerFechar = setTimeout(() => { this.aberto = false; }, 150);
      },
      disponiveis(lista, jaListados, manterEspacoFinal) {
        const atual = (this.value || '').trim();
        return (lista || [])
          .map(s => {
            const texto = (s || '').replace(/^\s+/, '').slice(0, this.maxlength);
            return manterEspacoFinal ? texto : texto.trim();
          })
          .filter((s, i, todos) => !!s.trim() && s.trim() !== atual && todos.indexOf(s) === i && jaListados.indexOf(s) < 0);
      },
      escolher(texto) {
        clearTimeout(this.timerFechar);
        this.aberto = false;
        this.$emit('input', texto.slice(0, this.maxlength));
      },
    },
    template: `
      <div class="cps" ref="campo">
        <input type="text" class="form-control" :maxlength="maxlength" :placeholder="placeholder"
               :value="value" @input="$emit('input', $event.target.value)"
               @focus="abrir" @click="abrir" @blur="fechar">
        <div v-if="aberto && temOpcoes" class="cps-lista" :style="estilo">
          <template v-if="sugestoesPrimeiro && opcoes.length > 0">
            <div class="cps-tit">{{ tituloSugestoes }}</div>
            <button v-for="(o, i) in opcoes" :key="'e' + i" type="button" class="cps-item" @mousedown.prevent="escolher(o)">
              {{ o }}
            </button>
          </template>
          <template v-if="opcoesDigitadas.length > 0">
            <div class="cps-tit">{{ tituloDigitados }}</div>
            <button v-for="(o, i) in opcoesDigitadas" :key="'d' + i" type="button" class="cps-item" @mousedown.prevent="escolher(o)">
              {{ o }}
            </button>
          </template>
          <template v-if="opcoesCadastradas.length > 0">
            <div class="cps-tit">Textos cadastrados</div>
            <button v-for="(o, i) in opcoesCadastradas" :key="'c' + i" type="button" class="cps-item" @mousedown.prevent="escolher(o)">
              {{ o }}
            </button>
          </template>
          <template v-if="!sugestoesPrimeiro && opcoes.length > 0">
            <div class="cps-tit">{{ tituloSugestoes }}</div>
            <button v-for="(o, i) in opcoes" :key="'e' + i" type="button" class="cps-item" @mousedown.prevent="escolher(o)">
              {{ o }}
            </button>
          </template>
        </div>
      </div>`,
  }
</script>

<style scoped>
  .cps { position: relative; }
  .cps-lista {
    position: fixed; z-index: 3300;
    background: #fff; border: 1px solid #d3d8de; border-radius: 6px; box-shadow: 0 6px 18px rgba(16,24,40,.14);
    overflow: auto;
  }
  .cps-tit {
    position: sticky; top: 0;
    padding: 6px 10px; font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: .05em;
    color: #8a939c; background: #f7f9fa; border-bottom: 1px solid #eceef1;
  }
  .cps-item {
    display: block; width: 100%; text-align: left; border: none; background: #fff;
    padding: 7px 10px; font-size: 12.5px; color: #2a3038; border-bottom: 1px solid #f2f3f5;
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  }
  .cps-item:last-child { border-bottom: none; }
  .cps-item:hover { background: #eef9f4; color: #0a6d4d; }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/ComplementoSugerido.vue